'use strict';

// external imports

// prime react imports

// shared imports
import {Column} from '~/shared/src/utilities/column';
import {Query} from '~/shared/src/utilities/query';
import {dataExtraction} from '~/shared/src/utilities/dataExtraction';
import {getDataStructureForSqlQuery} from '~/shared/src/utilities/modules/queryLoader';

// frontend imports


export const overviewUtilities = {
    getQuery: ( dataContext : string, overviewId : number ) : Query | undefined => {
        const overviewItem = global.data[ dataContext ]?.items?.[ overviewId ];

        return overviewItem ? dataExtraction.extractQuery( overviewItem, dataContext ) : undefined;
    },

    getColumns: ( dataContext : string, overviewId : number ) : Column[] | undefined => {
        const overviewItem = global.data[ dataContext ]?.items?.[ overviewId ],
              query        = overviewItem ? dataExtraction.extractQuery( overviewItem, dataContext ) : undefined;

        let retVal : Column[] | undefined = undefined;

        if ( overviewItem ) {
            retVal = dataExtraction.extractColumns( overviewItem, dataContext, query?.dataStructure ?? getDataStructureForSqlQuery() );
        }

        return retVal;
    }
}
